// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { ShapeElement } from './ShapeElement';
import { Double2D } from '../../../../../com/MetaPattern/MDA/Designer/Base/Double2D';
import { DiagramShape } from './DiagramShape';
import { ContainerShape } from './ContainerShape';
/**
 * 连接线图形 实体类
 * 定义所有的连接线的图形
 */
export class LineShape extends ShapeElement {
  /** 是否可见 : 定义图形的可见性，false则隐藏图形 */
  private _isVisible: boolean;

  /** 设置：是否可见 */
  public get isVisible() {
    return this._isVisible;
  }

  /** 获取：是否可见 */
  public set isVisible(value: boolean) {
    this._isVisible = value;
  }

  /** 起点坐标 : 起点的XY坐标 */
  private _sourcePoint: Double2D;

  /** 设置：起点坐标 */
  public get sourcePoint() {
    return this._sourcePoint;
  }

  /** 获取：起点坐标 */
  public set sourcePoint(value: Double2D) {
    this._sourcePoint = value;
  }

  /** 目标坐标 : 终点目标的XY坐标 */
  private _targetPoint: Double2D;

  /** 设置：目标坐标 */
  public get targetPoint() {
    return this._targetPoint;
  }

  /** 获取：目标坐标 */
  public set targetPoint(value: Double2D) {
    this._targetPoint = value;
  }

  /** 顶点 : 线的多个顶点，格式：x1,y1;x2,y2 */
  private _vertices: string;

  /** 设置：顶点 */
  public get vertices() {
    return this._vertices;
  }

  /** 获取：顶点 */
  public set vertices(value: string) {
    this._vertices = value;
  }

  /** 关系类型 : 关系类型。对应元数据的关系 */
  private _relationshipType: string;

  /** 设置：关系类型 */
  public get relationshipType() {
    return this._relationshipType;
  }

  /** 获取：关系类型 */
  public set relationshipType(value: string) {
    this._relationshipType = value;
  }

  /** 关系ID : 关系ID */
  private _relationshipId: string;

  /** 设置：关系ID */
  public get relationshipId() {
    return this._relationshipId;
  }

  /** 获取：关系ID */
  public set relationshipId(value: string) {
    this._relationshipId = value;
  }

  /** 图表 的ID */
  private _diagram_ID: string;

  /** 获取：图表 的ID */
  public get diagram_ID() {
    return this._diagram_ID;
  }

  /** 设置：图表 的ID */
  public set diagram_ID(value: string) {
    this._diagram_ID = value;
  }

  /** 图表  */
  private _diagram: DiagramShape;

  /** 获取：图表  */
  public get diagram() {
    return this._diagram;
  }

  /** 设置：图表  */
  public set diagram(value: DiagramShape) {
    this._diagram = value;
    if (value !== null) {
      this.diagram_ID = value.id;
    } else {
      this.diagram_ID = '';
    }
  }

  /** 容器 的ID */
  private _container_ID: string;

  /** 获取：容器 的ID */
  public get container_ID() {
    return this._container_ID;
  }

  /** 设置：容器 的ID */
  public set container_ID(value: string) {
    this._container_ID = value;
  }

  /** 容器  */
  private _container: ContainerShape;

  /** 获取：容器  */
  public get container() {
    return this._container;
  }

  /** 设置：容器  */
  public set container(value: ContainerShape) {
    this._container = value;
    if (value !== null) {
      this.container_ID = value.id;
    } else {
      this.container_ID = '';
    }
  }

  constructor() {
    super();
    this._isVisible = true;
    this._sourcePoint = new Double2D();
    this._targetPoint = new Double2D();
    this._vertices = '';
    this._relationshipType = '';
    this._relationshipId = '';
    this._diagram_ID = '';
    this._diagram = null;
    this._container_ID = '';
    this._container = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: LineShape, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isVisible = element.isVisible;
      this.sourcePoint = element.sourcePoint;
      this.targetPoint = element.targetPoint;
      this.vertices = element.vertices;
      this.relationshipType = element.relationshipType;
      this.relationshipId = element.relationshipId;
      this.diagram_ID = element.diagram_ID;
      if (hasReference && element.diagram !== null) {
        this.diagram = element.diagram;
      }
      this.container_ID = element.container_ID;
      if (hasReference && element.container !== null) {
        this.container = element.container;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isVisible = json.IsVisible;
    this.sourcePoint = new Double2D(json.SourcePoint.X, json.SourcePoint.Y);
    this.targetPoint = new Double2D(json.TargetPoint.X, json.TargetPoint.Y);
    this.vertices = json.Vertices;
    this.relationshipType = json.RelationshipType;
    this.relationshipId = json.RelationshipId;
    this.diagram_ID = json.Diagram_ID;
    // if (json.Diagram !== null) {
    //   this.diagram = DiagramShape.Create(json.Diagram);
    // }
    this.container_ID = json.Container_ID;
    // if (json.Container !== null) {
    //   this.container = ContainerShape.Create(json.Container);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsVisible = this.isVisible;
    json.SourcePoint = {};
    json.SourcePoint.X = this.sourcePoint.x;
    json.SourcePoint.Y = this.sourcePoint.y;
    json.TargetPoint = {};
    json.TargetPoint.X = this.targetPoint.x;
    json.TargetPoint.Y = this.targetPoint.y;
    json.Vertices = this.vertices;
    json.RelationshipType = this.relationshipType;
    json.RelationshipId = this.relationshipId;
    json.Diagram_ID = this.diagram_ID;
    json.Container_ID = this.container_ID;
  }

  static Create(json: any): LineShape {
    const lineShape = new LineShape();
    lineShape.Deserialize(json);
    lineShape.json = json;
    return lineShape;
  }
}
